import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkSetActivePanel } from '../../redux/actions/panelsActions';
import { useAppDispatch } from '../../redux/store';
import { ExitGameButtonGroup } from '../../scenes/poker/exitGameButtonGroup';
import { OpenModalContainer } from '../openModalContainer';
export const SelfActionsModal = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickViewSelf = useCallback(() => {
        dispatch(thunkSetActivePanel('self', socketSend));
        onClose();
    }, [dispatch, onClose, socketSend]);
    return (_jsx(OpenModalContainer, { maxWidth: 'xs', onClose: onClose, children: _jsx(DialogContent, { children: _jsxs("div", { css: css `
            display: flex;
            flex-direction: column;
            gap: 12px;
          `, children: [_jsx(ExitGameButtonGroup, { onClose: onClose }), _jsx("div", { css: css `
              margin-top: 15px;
            ` }), _jsx(Button, { onClick: onClickViewSelf, variant: 'outlined', children: "View Self" })] }) }) }));
};
